import { render, staticRenderFns } from "./WrestlingCover_c3.vue?vue&type=template&id=3e210df7&"
import script from "./WrestlingCover_c3.vue?vue&type=script&lang=js&"
export * from "./WrestlingCover_c3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports